import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    display: flex;
    justify-content: center;
    position: sticky;
    bottom: 0;
    z-index: 9;
    @media (max-height: 500px) {
      position: static;
    }
  `,
  navigation: css`
    width: 100%;
    height: 94px;
    background-color: ${colors.white};
    border-top: 0.5px solid ${colors.prussian400};
    box-shadow: rgba(0, 0, 0, 0.04) 0px 0px 0px -1px, rgba(0, 0, 0, 0.15) 0px -2px 4px 0px,
      rgba(0, 0, 0, 0.04) 0px 3px 3px -1.5px, rgba(0, 0, 0, 0.04) 0px 5px 2px -4px,
      rgba(0, 0, 0, 0.04) 0px -3px 8px 3px, rgba(0, 0, 0, 0.04) 0px 24px 24px -12px;
    @media (min-width: 800px) {
      max-width: 812px;
      height: 88px;
    }
  `,
  list: css`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
  `,
  action: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    min-width: auto;
    background: none;
    border: none;
    cursor: pointer;
    color: ${colors.slate};
    font-family: 'Montserrat Medium';
    gap: 4px;
    padding-top: 8px;
  `,
  actionSelected: css`
    color: ${colors.prussian};
  `,
  label: css`
    font-size: ${pxToRem(12)};
    line-height: 1.33;
    letter-spacing: -0.3px;
    @media (min-width: 800px) {
      font-size: ${pxToRem(14)};
    }
  `,
  labelSelected: css`
    font-family: 'Montserrat SemiBold';
    font-weight: 600;
  `,
};

export default styles;
